export function formatCurrency(currency: string, amount: number) {
  const safeAmount = Number.isFinite(amount) ? amount : 0
  return new Intl.NumberFormat("en-ZW", {
    style: "currency",
    currency: currency || "USD",
    currencyDisplay: "code",
    minimumFractionDigits: 2,
  }).format(safeAmount / 100)
}

export function formatCurrencyBreakdown(amounts: Array<{ currency: string; amount: number }> | null | undefined) {
  if (!amounts || amounts.length === 0) return "-"
  return amounts.map((entry) => formatCurrency(entry.currency ?? "USD", entry.amount ?? 0)).join(" · ")
}

export function formatDate(value?: string | null) {
  if (!value) return "-"
  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(new Date(value))
}

export function formatDateTime(value?: string | null) {
  if (!value) return "-"
  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "Africa/Harare",
  }).format(new Date(value))
}

export function maskPhone(phone: string) {
  if (phone.length < 7) return phone
  return `${phone.slice(0, 7)}***${phone.slice(-3)}`
}
